const map = {
	"./walk_frame_0.png": 2743,
	"./walk_frame_1.png": 3246,
	"./walk_frame_2.png": 1077,
	"./walk_frame_3.png": 8812,
	"./walk_frame_4.png": 6211,
	"./walk_frame_5.png": 650,
	"./walk_frame_6.png": 1729,
	"./walk_frame_7.png": 600
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3596;